// extracted by mini-css-extract-plugin
export default {"annoStatistic":"index_annoStatistic__zzkbu"};